import { render, staticRenderFns } from "./BcSnackbar.vue?vue&type=template&id=05b92f92&scoped=true"
import script from "./BcSnackbar.vue?vue&type=script&lang=ts"
export * from "./BcSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b92f92",
  null
  
)

export default component.exports